import React, { useState } from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isEmpty } from 'lodash-es';

import Button from '../../../components/Buttons/Button';
import InputText from '../../../components/Inputs/InputText';
import { validateEmail } from '../../../utils/helpers';
import { format, ISODateFormat, isMatch } from '../../../utils/date';

const emailError = 'Please provide a valid email address';

const validate = (value) => {
  if (!value || !value.trim()) return emailError;
  if (!validateEmail(value)) return emailError;
  return '';
};

const StateExpired = ({
  expiredOn,
  initialEmail,
  processing,
  responseError,
  bannerError,
  onSubmit,
}) => {
  const [email, setEmail] = useState(initialEmail);
  const [error, setError] = useState('');

  const formatDate = (value) =>
    value && isMatch(value, ISODateFormat) ? format(value, 'MMMM D, YYYY') : null;

  const handleChange = (value) => {
    setEmail(value);
    if (error) setError(validate(value));
  };

  const handleBlur = () => setError(validate(email));

  const handleSubmit = (e) => {
    e.preventDefault();
    const message = validate(email);
    setError(message);
    if (message) return;
    onSubmit({ email });
  };

  const fieldError = error || responseError.email;

  const renewalReviewCopy =
    "Enter your email to request renewal - you'll hear back once it's been reviewed.";
  const formattedDate = formatDate(expiredOn);

  const bodyText = formattedDate
    ? `Your 12-month access period ended on ${formattedDate}. ${renewalReviewCopy}`
    : `Your press access is no longer active. ${renewalReviewCopy}`;

  return (
    <div className="press-register-expired">
      <div className="press-register-expired__header">
        <h1 className="press-register-card__title">Your press access has expired</h1>
        <p className="press-register-card__subtitle">{bodyText}</p>
      </div>
      <form className="press-register-form" noValidate onSubmit={handleSubmit}>
        {!isEmpty(bannerError) && (
          <div className="press-register-form__banner">
            {bannerError.map((msg) => (
              <p key={msg}>{msg}</p>
            ))}
          </div>
        )}
        <fieldset
          className={cx('press-register-form__field', {
            'press-register-form__field--invalid': !!fieldError,
          })}
        >
          <label className="press-register-form__label" htmlFor="press-renewal-email">
            Work Email
          </label>
          <InputText
            id="press-renewal-email"
            size="lg"
            name="email"
            type="email"
            value={email}
            placeholder="name@company.com"
            isInvalid={!!fieldError}
            onChange={handleChange}
            onBlur={handleBlur}
          />
          {fieldError && <p className="press-register-form__error">{fieldError}</p>}
        </fieldset>
        <Button
          type="submit"
          size="lg"
          className="press-register-form__submit"
          loading={processing}
          disabled={processing}
        >
          Request Renewal
        </Button>
      </form>
    </div>
  );
};

StateExpired.propTypes = {
  expiredOn: T.string,
  initialEmail: T.string,
  processing: T.bool,
  responseError: T.object,
  bannerError: T.array,
  onSubmit: T.func.isRequired,
};

StateExpired.defaultProps = {
  expiredOn: '',
  initialEmail: '',
  processing: false,
  responseError: {},
  bannerError: [],
};

export default StateExpired;
